import { Fragment } from "react";
import * as React from "react";
import { useState } from "react";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import dayjs from 'dayjs';
import Button from "@mui/material/Button";
import { insertTodayDetails } from "../../services/AddDetails";

import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

export default function AddTodayDetails() {
  const [caloriesIntake, setCaloriesIntake] = useState("");
  const [weight, setWeight] = useState("");
  const [pickedDate, setPickedDate] = useState(dayjs().format("DD/MM/YYYY"));

  const addTodayDetailsHandler = () => {
    handleClick();
    insertTodayDetails(weight, caloriesIntake, pickedDate);
    setCaloriesIntake("");
    setWeight("");
    setPickedDate("");
  };

  const [open, setOpen] = React.useState(false);

  const handleClick = () => {
    setOpen(true);
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpen(false);
  };
  return (
    <Fragment>
      <div className="w-full text-2xl flex justify-center items-center p-6">
        <h1>Add Today's Details</h1>
      </div>
      <Box
        component="form"
        sx={{
          "& > :not(style)": { m: 1, width: "25ch" },
        }}
        noValidate
        autoComplete="off"
        className="w-full flex flex-col justify-center items-center py-2"
      >
        <TextField
          id="standard-basic"
          label="Weight"
          variant="standard"
          value={weight}
          onChange={(e) => setWeight(e.target.value)}
        />
        <TextField
          id="standard-basic"
          label="Calories Intake"
          variant="standard"
          value={caloriesIntake}
          onChange={(e) => setCaloriesIntake(e.target.value)}
        />
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DatePicker
            label="Pick a date"
            value={dayjs(pickedDate).format("DD/MM/YYYY")}
            onChange={(date) => setPickedDate(dayjs(date).format("DD/MM/YYYY"))}
            renderInput={(params) => <TextField {...params} />}
            defaultValue={dayjs(pickedDate).format("DD/MM/YYYY")}
          />
        </LocalizationProvider>
        <Button variant="contained" onClick={addTodayDetailsHandler}>
          Add / Update
        </Button>
      </Box>
      <Snackbar open={open} autoHideDuration={2000} onClose={handleClose}>
        <Alert onClose={handleClose} severity="success" sx={{ width: "100%" }}>
          Successfully Added!
        </Alert>
      </Snackbar>
    </Fragment>
  );
}
